// Module
var code = "<div class=\"light-gray-border-top\"><div flex layout=\"row\" ng-if=\"$ctrl.discounts.length > 0\" ng-repeat=\"discount in $ctrl.discounts\"><div flex=\"100\"><h4>{{discount.name}} <span ng-if=\"discount.code\">({{discount.code}})</span></h4><p>{{discount.description}}</p></div></div></div>";
// Exports
module.exports = code;